const SkinAnalysisIcons = {
  darkcircles: 'darkcircles',
  eyebags: 'eyebags',
  eyecolor: 'eyecolor',
  pigmentvariation: 'pigmentvariation',
  radiance: 'radiance',
  shape: 'shape',
  undertone: 'undertone',
  wrinkleslines: 'wrinkleslines',
  skintoneColor: 'skintoneColor',
  acne: 'acne',
  skinShine: 'skinShine',
  redness: 'redness',
  texture: 'texture',
};
export default SkinAnalysisIcons;



// WEBPACK FOOTER //
// ./src/components/instore/SkinAnalysisIcons.js